var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters",class:_vm.customClasses},[_c('TheFiltersActions',{on:{"update":_vm.handleUpdate,"reset":_vm.handleReset}}),_c('TheCategories',{ref:"categories",attrs:{"categories":_vm.categories,"context":'filters'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }